import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import DOMPurify from 'dompurify';

const DOM_PURIFY_CONFIG = {
  ALLOWED_TAGS: [
    'b', 'i', 'em', 'strong', 'a', 'p', 'div', 'span', 's', 'u', 'ul', 'ol', 'li', 'br', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  ],
  ALLOWED_ATTR: [
    'href',
    'style',
    'target',
    'rel',
    'class'
  ],
  FORBID_ATTR: [
    'onerror', 'onclick', 'onload', 'onmouseover'
  ],
  ALLOW_UNKNOWN_PROTOCOLS: false
};

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    value = DOMPurify.sanitize(value, DOM_PURIFY_CONFIG);
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
